import { getToken } from '@/libs/util.token'
export default ({ request }) => ({
  ecomPlatformOrderListApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/platform/order/list',
      method: 'POST',
      data,
    })
  },
  ecomPlatformOrderDetailApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/platform/order/detail',
      method: 'POST',
      data,
    })
  },
  ecomPlatformOrderWebOrderListApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/platform/order/platform/orders',
      method: 'POST',
      data,
      timeout: 60000,
    })
  },
  ecomPlatformOrderPlatformSelectApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/platform/order/platform/select',
      method: 'POST',
      data,
    })
  },
  ecomPlatformOrderSyncOrdersApi(data = {}) {
    return request({
      url: '/ecomorder/ecom/platform/order/sync/orders',
      method: 'POST',
      data,
      timeout: 60000,
    })
  },
  ecomPlatformOrderImportSPSTargetApi(file) {
    const data = new FormData()
    data.append('file', file)

    return request({
      url: '/ecomorder/ecom/platform/order/import/sps/target',
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: getToken() || '',
      },
      timeout: 60000,
    })
  },
  ecomPlatformOrderImportOrderApi({ platformCode, general, file }) {
    const data = new FormData()
    data.append('file', file)
    data.append('platformCode', platformCode)
    data.append('general', general)

    return request({
      url: '/ecomorder/ecom/platform/order/import/order',
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: getToken() || '',
      },
      timeout: 60000,
    })
  },
})
